// Dependencies imports
import React, {useState} from 'react';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { API } from "aws-amplify";

// Local imports
import config from '../../../config/aws-exports';
import CourseView from './CourseView';
import { awsSignIn, authData } from "../../../redux/auth/authSlice";
import { Constants } from "../../../config/constants";

// Style imports
import Inst from "./InstructorAnalytics.module.scss";


const header = {
    color: "white",
    fontFamily: "nunito",
    fontSize: "15px",
    fontWeight: "400px",
  };

const programnames = {
    color: config.main_color_1,
    fontFamily: "nunito",
    fontSize: "16px",
    fontWeight: "500px",
};


const useStyles = makeStyles({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
    },
});


export default function InstructorAnalytics(props) {
    let { sessionCount } = props;
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const [name, setName] = useState();
    console.log("Sessioncount inside", sessionCount);
    const [loading, setLoading] = useState(false);
    const [ courseView, setCourseView] = useState(undefined);
    const dispatch = useDispatch();
    let userDetails = useSelector(authData);

    console.log("userdetails", userDetails);

    // API for BatchView
    async function getBatchView(value) {
        setLoading(true);
        const bodyParam = {
          body: {
            oid: config.aws_org_id,
            bpid: userDetails.curprgcou.bpid,
            cid: userDetails.bcid,
            eid: value,
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        };
        try {
          console.log(bodyParam.body);
          const response = await API.post(
            config.aws_cloud_logic_custom_name,
            Constants.GET_INSTRUCTOR_SESSION,
            bodyParam
          );
          console.log("response", response);
          if(response === undefined || response === null || response.length === 0 ){
            setCourseView(undefined);
          }
          else {
            setCourseView(response);
          }
          
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.error(error);
        }
      }


    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    }




    // Main return starts here
    return (
        <div className={Inst.maincontainer}>
            <h3 className={Inst.heading}>Instructors</h3>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <CourseView handleClose={handleClose} courseView={courseView} name={name}  loading={loading} />
                </Fade>
            </Modal>
            <div className={Inst.tablecontainer}>
                <Table>
                    <TableHead style={{ background: config.main_color_1 }}>
                            <TableRow>
                                <TableCell style={{width: "20%"}}><h4 style={header}>Sl.No</h4></TableCell>
                                <TableCell style={{width: "40%"}}><h4 style={header}>Name</h4></TableCell>
                                <TableCell style={{width: "40%"}}><h4 style={header}>No.of live sessions</h4></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sessionCount === undefined || sessionCount === null ?  
                            <TableRow style={{width: "100%"}}>
                                <TableCell></TableCell>
                                <TableCell style={programnames}>Select Course and Semester</TableCell>
                                <TableCell></TableCell>
                            </TableRow> 
                            : sessionCount.length === 0 ? 
                            <TableRow style={{width: "100%"}}>
                                <TableCell></TableCell>
                                <TableCell style={programnames}>No Data</TableCell>
                                <TableCell></TableCell>
                            </TableRow> :
                                sessionCount.map((value,index) => {
                                    
                            return (
                                <TableRow onClick={value.count === 0 ? null : ()=> {handleOpen(); setName(value.UNAME); getBatchView(value.EID)}} className={value.count === 0 ? Inst.notallowed : Inst.counts}>
                                <TableCell style={programnames}>{index+1}</TableCell>
                                <TableCell style={programnames}>{value.UNAME}</TableCell>
                                <TableCell style={programnames}>{value.count}</TableCell>
                            </TableRow>)})
                            }
                        </TableBody>
                </Table>
            </div>
        </div>
    )
}
